import {
  DeleteFilled,
  ExclamationCircleOutlined,
  PlusOutlined,
  StarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  Empty,
  message,
  Modal,
  Row,
  Space,
  Spin,
  Tag,
} from "antd";
import { todoApi } from "api/todo.api";
import dayjs from "utils/dayjs";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { QueryParam } from "types/query";
import { Todo } from "types/todo";
import { AddTaskModal } from "../AddTaskModal";

export const TodoModal = ({
  todoVisible,
  focusTodoId,
  shopId,
  onClose,
  onSubmitOk,
}: {
  todoVisible: boolean;
  focusTodoId?: number;
  shopId?: number;
  onClose: () => void;
  onSubmitOk?: () => void;
}) => {
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState<ModalStatus>("create");
  const [selectedTask, setSelectedTask] = useState<Todo>();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState<QueryParam>({
    page: 1,
    limit: 20,
  });
  const [todoList, setTodoList] = useState<Todo[]>();

  useEffect(() => {
    if (shopId) {
      fetchTodo();
    }
  }, [shopId]);

  const fetchTodo = async () => {
    setLoading(true);
    const res = await todoApi.findAll({ ...query, shopId });
    setLoading(false);
    setTodoList(res.data.todos);
    setTotal(res.data.total);
  };

  const handelComplete = async (todo: Todo, isComplete: boolean) => {
    try {
      setLoading(true);
      await todoApi.complete(todo.id);
      message.success("Đã đánh dấu hoàn thành");
      fetchTodo();
      if (onSubmitOk) {
        onSubmitOk();
      }
    } finally {
      setLoading(false);
    }
  };

  return (<>
    <Modal
      title="Log công việc"
      open={todoVisible}
      cancelText="Đóng"
      onCancel={onClose}
      footer={null}
    >
      <div>
        <Spin spinning={loading}>
          <Row>
            <Col span={24} style={{ margin: "auto" }}>
              <div className="form-section">
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setStatus("create");
                    setVisible(true);
                  }}
                >
                  Tạo mới
                </Button>
                <Row style={{ marginTop: "1em" }}>
                  {todoList?.map((todo) => {
                    // if (focusTodoId == todo.id)
                    return (
                      <TodoItem
                        key={todo.id}
                        focusTodoId={focusTodoId}
                        data={todo}
                        onUpdate={() => {
                          setSelectedTask(todo);
                          setStatus("update");
                          setVisible(true);
                        }}
                        onFetchData={() => {
                          fetchTodo();
                          onSubmitOk && onSubmitOk();
                        }}
                        onComplete={(status) => handelComplete(todo, status)}
                      />
                    );
                  })}
                  <Space
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: 200,
                      width: "100%",
                    }}
                  >
                    {todoList?.length == 0 && <Empty />}
                  </Space>
                </Row>
              </div>
            </Col>
          </Row>
        </Spin>
      </div>
    </Modal>
    <AddTaskModal
      visible={visible}
      onClose={() => setVisible(false)}
      onSubmitOk={() => {
        fetchTodo();
        if (onSubmitOk) {
          onSubmitOk();
        }
      }}
      selectedTask={selectedTask}
      status={status}
      shopId={shopId}
    />
  </>);
};

export const TodoItem = ({
  data,
  focusTodoId,
  onUpdate,
  onComplete,
  onFetchData,
}: {
  data: Todo;
  focusTodoId?: number;
  onComplete: (status: boolean) => void;
  onUpdate: () => void;
  onFetchData: () => void;
}) => {
  const confirm = (id: number) => {
    Modal.confirm({
      title: `Xác nhận`,
      icon: <ExclamationCircleOutlined />,
      content: `Xác nhận xóa công việc này?`,
      okText: "Xóa",
      okButtonProps: { danger: true },
      cancelText: "Hủy",
      onOk: () => handleDelete(id),
    });
  };

  const handleDelete = async (id: number) => {
    await todoApi.delete(id);
    message.success("Delete successfully");
    onFetchData();
  };
  return (
    <div className={`todo-item ${focusTodoId == data.id ? "focus" : ""}`}>
      <Space
        onClick={() => {
          if (!data.isCompleted) {
            onUpdate();
          }
        }}
        style={{
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Checkbox
            disabled={!data.expiredAt}
            checked={data.isCompleted}
            onChange={(value) => onComplete(value.target.checked)}
            style={{ marginRight: "1em" }}
            onClick={(e) => e.stopPropagation()}
          ></Checkbox>
          <Space style={{ width: "100%" }} direction="vertical">
            {data.expiredAt && (
              <b>{dayjs.unix(data.expiredAt).format("DD/MM/YYYY")}</b>
            )}

            {data.expiredAt &&
              data.expiredAt < dayjs().unix() &&
              !data.isCompleted && (
                <Tag color={"red"}>
                  <b>Out of date</b>{" "}
                </Tag>
              )}

            {/* {data.createdStaff && (
              <Space style={{ fontWeight: 800 }}>
                <Avatar
                  size={20}
                  icon={<UserOutlined />}
                  src={data?.createdStaff?.avatar}
                />
                {data?.createdStaff?.name}
              </Space>
            )} */}

            <p style={{ marginBottom: 0 }}>{data.content}</p>
          </Space>
        </div>
        {!data.isCompleted && (
          <Button
            className="delete-btn"
            type="text"
            icon={<DeleteFilled />}
            danger
            onClick={(e) => {
              e.stopPropagation();
              confirm(data.id);
            }}
          ></Button>
        )}
      </Space>
    </div>
  );
};
